/** Map a final run total (summed over all five stages) to a flavourful rank.
 *  Thresholds are calibrated to the proven optimal run of ~2355. The first
 *  clause (before " — ") is used as a short rank label in the comparison. */
export function rankFor(v: number): string {
  if (v >= 2100) return "Hoard Master — the dragon would be jealous";
  if (v >= 1700) return "Master Plunderer";
  if (v >= 1200) return "Seasoned Looter";
  if (v >= 700) return "Apprentice Thief";
  return "Hapless Pack Rat";
}
